import { AspectRatio, Theme, SlideTemplate, AnimationEffect } from '../types';

export const ASPECT_RATIOS: AspectRatio[] = [
  { label: '16:9 (Widescreen)', value: '16:9', width: 1920, height: 1080 },
  { label: '16:10 (Computer)', value: '16:10', width: 1920, height: 1200 },
  { label: '4:3 (Standard)', value: '4:3', width: 1440, height: 1080 },
  { label: '21:9 (Ultrawide)', value: '21:9', width: 1680, height: 720 },
  { label: '1:1 (Square)', value: '1:1', width: 1080, height: 1080 },
  { label: '3:2 (Classic)', value: '3:2', width: 1620, height: 1080 },
  { label: '9:16 (Mobile)', value: '9:16', width: 1080, height: 1920 },
];

export const DEFAULT_THEMES: Theme[] = [
  // Adobe Recommended Color Schemes - Vibrant
  { primary: '#FF6B35', secondary: '#004E89', accent: '#1A936F', quaternary: '#6B7280' }, // Orange-Blue-Green-Gray
  { primary: '#6D3BFF', secondary: '#FF3B9D', accent: '#3BFFB5', quaternary: '#4B5563' }, // Purple-Pink-Teal-Dark Gray
  { primary: '#E74C3C', secondary: '#3498DB', accent: '#F39C12', quaternary: '#9CA3AF' }, // Red-Blue-Orange-Light Gray
  { primary: '#9B59B6', secondary: '#0ABC9C', accent: '#F1C40F', quaternary: '#374151' }, // Purple-Teal-Yellow-Dark Gray
  
  // Adobe Professional Schemes
  { primary: '#2C3E50', secondary: '#E74C3C', accent: '#ECF0F1', quaternary: '#6B7280' }, // Dark Blue-Red-Light Grey-Gray
  { primary: '#16A085', secondary: '#F4D03F', accent: '#E8DAEF', quaternary: '#9CA3AF' }, // Teal-Yellow-Lavender-Light Gray
  { primary: '#8E44AD', secondary: '#58D68D', accent: '#F8C471', quaternary: '#4B5563' }, // Purple-Green-Peach-Dark Gray
  { primary: '#D35400', secondary: '#5DADE2', accent: '#A9DFBF', quaternary: '#374151' }, // Orange-Blue-Mint-Dark Gray
  
  // Adobe Sophisticated Schemes  
  { primary: '#34495E', secondary: '#E67E22', accent: '#BDC3C7', quaternary: '#6B7280' }, // Dark Grey-Orange-Silver-Gray
  { primary: '#1B4F72', secondary: '#DC7633', accent: '#D5DBDB', quaternary: '#9CA3AF' }, // Navy-Orange-Light Grey-Light Gray
  { primary: '#922B21', secondary: '#2ECC71', accent: '#F8F9FA', quaternary: '#4B5563' }, // Maroon-Green-White-Dark Gray
  { primary: '#6C3483', secondary: '#F39C12', accent: '#EBF5FB', quaternary: '#374151' }, // Purple-Orange-Ice Blue-Dark Gray
  
  // Adobe Monochromatic + Accent
  { primary: '#2C3E50', secondary: '#34495E', accent: '#E74C3C', quaternary: '#6B7280' }, // Blue Grey Mono + Red-Gray
  { primary: '#8E44AD', secondary: '#A569BD', accent: '#F1C40F', quaternary: '#9CA3AF' }, // Purple Mono + Yellow-Light Gray
  { primary: '#16A085', secondary: '#48C9B0', accent: '#E74C3C', quaternary: '#4B5563' }, // Teal Mono + Red-Dark Gray
  { primary: '#D35400', secondary: '#E67E22', accent: '#3498DB', quaternary: '#374151' }, // Orange Mono + Blue-Dark Gray
  
  // Adobe Muted Sophistication
  { primary: '#5D6D7E', secondary: '#AEB6BF', accent: '#DC7633', quaternary: '#6B7280' }, // Grey-Silver-Orange-Gray
  { primary: '#76448A', secondary: '#BB8FCE', accent: '#F7DC6F', quaternary: '#9CA3AF' }, // Purple-Light Purple-Yellow-Light Gray
  { primary: '#1F618D', secondary: '#05B1B9', accent: '#F8C471', quaternary: '#4B5563' }, // Blue-Light Blue-Peach-Dark Gray
  
  // 새로운 모노크롬 색상 조합 (흰색, 회색, 짙은회색, 검정) / 여기는 절대 수정하지 말기
  { primary: '#8F8F8F', secondary: '#000000', accent: '#6B7280', quaternary: '#1F2937' }, // White-Light Gray-Gray-Dark Gray
];

export const SLIDE_TEMPLATES: SlideTemplate[] = [
  { id: 'title-center', name: 'Title Center', preview: '📄', layout: 'title-center' },
  { id: 'title-left', name: 'Title Left', preview: '📋', layout: 'title-left' },
  { id: 'title-top', name: 'Title Top', preview: '📊', layout: 'title-top' },
  { id: 'split-content', name: 'Split Content', preview: '📑', layout: 'split-content' },
  { id: 'title-bottom', name: 'Title Bottom', preview: '📝', layout: 'title-bottom' },
  { id: 'title-right', name: 'Title Right', preview: '📰', layout: 'title-right' },
];

export const ANIMATION_EFFECTS: AnimationEffect[] = [
  { type: 'none', duration: 0, delay: 0 },
  { type: 'fadeIn', duration: 1000, delay: 0 },
  { type: 'slideInLeft', duration: 800, delay: 0 },
  { type: 'slideInRight', duration: 800, delay: 0 },
  { type: 'slideInUp', duration: 800, delay: 0 },
  { type: 'slideInDown', duration: 800, delay: 0 },
  { type: 'zoomIn', duration: 600, delay: 0 },
  { type: 'bounceIn', duration: 1200, delay: 0 },
];

export const PEXELS_PHOTOS = [
  'https://images.pexels.com/photos/3184338/pexels-photo-3184338.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/3184341/pexels-photo-3184341.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
];

export const FONT_FAMILIES = [
  'Inter, system-ui, sans-serif',
  'Roboto, sans-serif',
  'Open Sans, sans-serif',
  'Lato, sans-serif',
  'Montserrat, sans-serif',
  'Poppins, sans-serif',
  'Source Sans Pro, sans-serif',
  'Nunito, sans-serif',
  'Raleway, sans-serif',
  'Ubuntu, sans-serif',
];

// 프리미엄 디자인 템플릿 패턴 정의
export const DESIGN_TEMPLATES = {
  // 제목 페이지 템플릿
  titlePage: {
    name: "제목 페이지",
    structure: "hero-layout",
    elements: ["title", "subtitle", "accent-line", "background-icon"],
    style: "bold-typography",
    description: "대형 제목과 부제목이 있는 인상적인 오프닝 페이지"
  },
  
  // 개념 소개 템플릿
  conceptIntro: {
    name: "개념 소개",
    structure: "split-content",
    elements: ["title", "definition-box", "visual-diagram", "key-points"],
    style: "clean-educational",
    description: "주요 개념을 설명하고 시각적으로 표현하는 템플릿"
  },
  
  // 분류/카테고리 템플릿
  categoryGrid: {
    name: "분류 그리드",
    structure: "grid-layout",
    elements: ["title", "category-cards", "icons", "feature-lists"],
    style: "card-based",
    description: "여러 항목을 카드 형태로 분류하여 보여주는 템플릿"
  },
  
  // 상세 분석 템플릿
  detailAnalysis: {
    name: "상세 분석",
    structure: "two-column",
    elements: ["title", "main-content", "examples", "comparison", "background-visual"],
    style: "content-heavy",
    description: "깊이 있는 내용과 예시를 포함한 분석 페이지"
  },
  
  // 결론/요약 템플릿
  conclusionSummary: {
    name: "결론 요약",
    structure: "summary-layout",
    elements: ["title", "summary-items", "checklist", "action-items"],
    style: "conclusion-focused",
    description: "핵심 내용 요약과 실행 가능한 항목들이 있는 마무리 페이지"
  }
};

// 슬라이드 시퀀스 구조 (기승전결)
export const SLIDE_SEQUENCE_PATTERNS = {
  // 4페이지 기본 구조
  fourSlideBasic: {
    intro: { template: "titlePage", purpose: "주제 소개 및 관심 유발" },
    development: { template: "conceptIntro", purpose: "핵심 개념 설명" },
    climax: { template: "detailAnalysis", purpose: "심화 내용 및 분석" },
    conclusion: { template: "conclusionSummary", purpose: "요약 및 마무리" }
  },
  
  // 6페이지 확장 구조
  sixSlideExtended: {
    intro: { template: "titlePage", purpose: "주제 소개" },
    background: { template: "conceptIntro", purpose: "배경 지식" },
    classification: { template: "categoryGrid", purpose: "분류 및 카테고리" },
    analysis1: { template: "detailAnalysis", purpose: "첫 번째 상세 분석" },
    analysis2: { template: "detailAnalysis", purpose: "두 번째 상세 분석" },
    conclusion: { template: "conclusionSummary", purpose: "종합 결론" }
  }
};

// 디자인 스타일 가이드
export const DESIGN_STYLE_GUIDE = {
  colorPalettes: {
    professional: {
      primary: "#00356B",
      secondary: "#2c5282", 
      accent: "#A51C30",
      background: "#f8fafc",
      text: "#1a365d"
    },
    modern: {
      primary: "#1a202c",
      secondary: "#2d3748",
      accent: "#3182ce",
      background: "#f7fafc",
      text: "#2d3748"
    },
    vibrant: {
      primary: "#2b6cb0",
      secondary: "#3182ce",
      accent: "#ed8936", 
      background: "#ebf8ff",
      text: "#1a365d"
    }
  },
  
  typography: {
    title: "font-size: 2.5rem; font-weight: 700; line-height: 1.2;",
    subtitle: "font-size: 1.4rem; font-weight: 500;",
    content: "font-size: 1.2rem; line-height: 1.6;",
    caption: "font-size: 0.9rem; line-height: 1.4;"
  },
  
  layouts: {
    heroLayout: "전체 중앙 정렬, 대형 타이포그래피",
    splitContent: "좌우 2분할 레이아웃",
    gridLayout: "2x2 또는 2x3 그리드 구조",
    twoColumn: "좌측 주요 내용, 우측 보조 내용",
    summaryLayout: "상하 구조로 요약 정보 배치"
  },
  
  visualElements: {
    backgroundIcons: "반투명 배경 아이콘으로 주제 표현",
    accentLines: "4px 높이의 브랜드 컬러 라인",
    contentBoxes: "좌측 테두리가 있는 반투명 박스",
    cardComponents: "둥근 모서리와 그림자가 있는 카드",
    iconography: "FontAwesome 아이콘 적극 활용"
  }
};

export const TRANSLATIONS = {
  ko: {
    title: 'AI 슬라이드 생성',
    settings: '설정',
    content: '콘텐츠',
    contentPlaceholder: '프레젠테이션 내용을 입력하세요. 각 단락이 슬라이드가 됩니다...',
    themeColors: '테마 색상',
    slideAspectRatio: '슬라이드 비율',
    generateSlides: '슬라이드 생성',
    generating: '생성 중...',
    exportPDF: 'PDF 내보내기',
    exportHTML: 'HTML 내보내기',
    noSlidesGenerated: '아직 생성된 슬라이드가 없습니다',
    addContentAndGenerate: '콘텐츠를 작성하고 [슬라이드 생성] 버튼을 클릭하세요',
    generatedSlides: '생성된 슬라이드',
    addSlide: '여기에 슬라이드 추가',
    addSlideHere: '여기에 슬라이드 추가',
    preview: '미리보기',
    html: 'HTML',
    editSlide: '슬라이드 편집',
    modificationRequest: 'AI 수정 요청',
    modificationPlaceholder: '이 슬라이드를 어떻게 수정하고 싶은지 설명하세요...',
    updateSlide: '슬라이드 업데이트',
    updating: '업데이트 중...',
    newSlide: '새 슬라이드',
    addContentHere: '여기에 콘텐츠를 추가하세요...',
    geminiApiKey: 'Gemini API 키',
    geminiApiKeyPlaceholder: 'Google Gemini API 키를 입력하세요',
    apiSettings: 'API 설정',
    saveApiKey: 'API 키 저장',
    apiKeyRequired: 'Gemini API 키가 필요합니다',
    language: '언어',
    korean: '한국어',
    english: 'English',
    templates: '템플릿',
    selectTemplate: '템플릿 선택',
    changeBackground: '배경 변경',
    uploadImage: '이미지 업로드',
    searchImages: '이미지 검색',
    searchImagesPlaceholder: '이미지를 검색하세요...',
    noImagesFound: '이미지를 찾을 수 없습니다',
    textProperties: '텍스트 속성',
    fontSize: '글자 크기',
    fontFamily: '글꼴',
    fontColor: '글자 색상',
    fontWeight: '글자 굵기',
    textAlign: '정렬',
    animation: '애니메이션',
    animationType: '애니메이션 유형',
    animationDuration: '지속 시간',
    animationDelay: '지연 시간',
    undo: '실행 취소',
    redo: '다시 실행',
    applyChanges: '변경사항 적용',
    saved: '저장됨',
    none: '없음',
    fadeIn: '페이드 인',
    slideInLeft: '왼쪽에서 슬라이드',
    slideInRight: '오른쪽에서 슬라이드',
    slideInUp: '아래에서 슬라이드',
    slideInDown: '위에서 슬라이드',
    zoomIn: '확대',
    bounceIn: '바운스',
    left: '왼쪽',
    center: '가운데',
    right: '오른쪽',
    normal: '보통',
    bold: '굵게',
    bolder: '더 굵게',
    borderStyle: '테두리 스타일',
    boxStyle: '박스 스타일',
    noStyle: '스타일 없음',
    noBorder: '테두리 없음',
    cleanBox: '깔끔한 박스',
    cleanLine: '깔끔한 선',
    modernCard: '모던 카드',
    boldFrame: '굵은 프레임',
    dashedCreative: '점선 창의적',
    dottedPlayful: '점점 재미있는',
    doubleProfessional: '이중선 전문적',
    glowEffect: '글로우 효과',
    circleLine: '서클 라인',
    frame: '액자',
    postIt: '포스트잇',
    polaroid: '즉석 사진',
    analog: '아날로그',
    retroComputer: '레트로 컴퓨터',
    glassMorphic: '글래스모픽',
    bullet: '불릿',
    jigsaw: '직소',
    burnt: '그을림',
    hole: '구멍',
    pencil: '연필',
    pin: '핀셋',
    shadowNone: '그림자 없음',
    shadowLight: '약한 그림자',
    shadowMedium: '중간 그림자',
    shadowStrong: '강한 그림자',
    shadowLong: '롱 섀도우',
    mixedAuto: '자동 혼합',
    mixedAutoDesc: '자동',
    presentationFormal: '정식 발표',
    presentationFormalDesc: '정형화',
    sideBySide: '좌우 분할',
    sideBySideDesc: '좌우분할',
    titleFocus: '제목 중심',
    titleFocusDesc: '제목중심',
    contentHeavy: '내용 중심',
    contentHeavyDesc: '내용중심',
    creativeAsymmetric: '크리에이티브',
    creativeAsymmetricDesc: '창의적',
    selected: '선택됨',
    slide: '슬라이드',
    saveImage: '이미지',
    confirmDeleteSlide: '이 슬라이드를 삭제하시겠습니까?',
    autoSaving: '자동 저장 중...',
    saveChanges: '변경사항 저장',
    confirmExitWithUnsaved: '저장하지 않은 변경사항이 있습니다. 편집을 종료하시겠습니까?',
    exitEdit: '편집 종료',
    enterTitle: '제목을 입력하세요',
    enterContent: '내용을 입력하세요',
    enterText: '텍스트를 입력하세요',
    invalidImageFormat: '잘못된 이미지 형식',
    imageProperties: '이미지 속성',
    newText: '새 텍스트',
    priority: '우선순위',
    text: '텍스트',
    lighter: '가늘게',
    width: '너비',
    height: '높이',
    rotation: '회전',
    resetRotation: '회전 초기화',
    reset: '초기화',
    changeImage: '이미지 변경',
    edit: '편집',
    resize: '크기 조절',
    dragToMove: '이동하려면 드래그하세요',
    delete: '삭제',
    deleted: '삭제되었습니다',
    confirmDelete: '요소를 삭제하시겠습니까?',
    deleteWarning: '이 작업은 되돌릴 수 없습니다.',
    dragToRotate: '회전하려면 드래그하세요',
    closePropertyPanel: '속성 패널 닫기',
    sendToBack: '뒤로 보내기',
    bringToFront: '앞으로 보내기',
    deleteElement: '요소 삭제',
    popupBlocked: '팝업이 차단되었습니다. 팝업을 허용해주세요.',
    generatingImage: '이미지 생성 중...',
    generatingSlideImage: '슬라이드 이미지 생성 중...',
    pleaseWait: '잠시만 기다려주세요.',
    imageGenerationComplete: '이미지 생성 완료!',
    downloadStarting: '다운로드가 시작됩니다...',
    closeWindow: '창 닫기',
    errorOccurred: '오류 발생',
    imageGenerationError: '이미지 생성 중 오류가 발생했습니다.',
  },
  en: {
    title: 'AI Slide Generator',
    settings: 'Settings',
    content: 'Content',
    contentPlaceholder: 'Enter your presentation content here. Each paragraph will become a slide...',
    themeColors: 'Theme Colors',
    slideAspectRatio: 'Slide Aspect Ratio',
    generateSlides: 'Generate Slides',
    generating: 'Generating...',
    exportPDF: 'Export PDF',
    exportHTML: 'Export HTML',
    noSlidesGenerated: 'No slides generated yet',
    addContentAndGenerate: 'Add content and click "Generate Slides" to get started',
    generatedSlides: 'Generated Slides',
    addSlide: 'Add Slide',
    addSlideHere: 'Add slide here',
    preview: 'Preview',
    html: 'HTML',
    editSlide: 'Edit Slide',
    modificationRequest: 'AI Modification Request',
    modificationPlaceholder: 'Describe how you want to modify this slide...',
    updateSlide: 'Update Slide',
    updating: 'Updating...',
    newSlide: 'New Slide',
    addContentHere: 'Add your content here...',
    geminiApiKey: 'Gemini API Key',
    geminiApiKeyPlaceholder: 'Enter your Google Gemini API key',
    apiSettings: 'API Settings',
    saveApiKey: 'Save API Key',
    apiKeyRequired: 'Gemini API key is required',
    language: 'Language',
    korean: '한국어',
    english: 'English',
    templates: 'Templates',
    selectTemplate: 'Select Template',
    changeBackground: 'Change Background',
    uploadImage: 'Upload Image',
    searchImages: 'Search Images',
    searchImagesPlaceholder: 'Search for images...',
    noImagesFound: 'No images found',
    textProperties: 'Text Properties',
    fontSize: 'Font Size',
    fontFamily: 'Font Family',
    fontColor: 'Font Color',
    fontWeight: 'Font Weight',
    textAlign: 'Text Align',
    animation: 'Animation',
    animationType: 'Animation Type',
    animationDuration: 'Duration',
    animationDelay: 'Delay',
    undo: 'Undo',
    redo: 'Redo',
    applyChanges: 'Apply Changes',
    saved: 'Saved',
    none: 'None',
    fadeIn: 'Fade In',
    slideInLeft: 'Slide In Left',
    slideInRight: 'Slide In Right',
    slideInUp: 'Slide In Up',
    slideInDown: 'Slide In Down',
    zoomIn: 'Zoom In',
    bounceIn: 'Bounce In',
    left: 'Left',
    center: 'Center',
    right: 'Right',
    normal: 'Normal',
    bold: 'Bold',
    bolder: 'Bolder',
    borderStyle: 'Border Style',
    boxStyle: 'Box Style',
    noStyle: 'No Style',
    noBorder: 'No Border',
    cleanBox: 'Clean Box',
    cleanLine: 'Clean Line',
    modernCard: 'Modern Card',
    boldFrame: 'Bold Frame',
    dashedCreative: 'Dashed Creative',
    dottedPlayful: 'Dotted Playful',
    doubleProfessional: 'Double Professional',
    glowEffect: 'Glow Effect',
    circleLine: 'Circle Line',
    frame: 'Frame',
    postIt: 'Post-it',
    polaroid: 'Polaroid',
    analog: 'Analog',
    retroComputer: 'Retro Computer',
    glassMorphic: 'Glassmorphic',
    bullet: 'Bullet',
    jigsaw: 'Jigsaw',
    burnt: 'Burnt',
    hole: 'Hole',
    pencil: 'Pencil',
    pin: 'Pin',
    shadowNone: 'No Shadow',
    shadowLight: 'Light Shadow',
    shadowMedium: 'Medium Shadow',
    shadowStrong: 'Strong Shadow',
    shadowLong: 'Long Shadow',
    templateStyle: 'Template Style',
    mixedAuto: 'Auto Mixed',
    mixedAutoDesc: 'Auto',
    presentationFormal: 'Formal Presentation',
    presentationFormalDesc: 'Formal',
    sideBySide: 'Side by Side',
    sideBySideDesc: 'Split',
    titleFocus: 'Title Focus',
    titleFocusDesc: 'Title',
    contentHeavy: 'Content Heavy',
    contentHeavyDesc: 'Heavy',
    creativeAsymmetric: 'Creative',
    creativeAsymmetricDesc: 'Creative',
    selected: 'Selected',
    slide: 'Slide',
    saveImage: 'Save Image',
    confirmDeleteSlide: 'Delete this slide?',
    autoSaving: 'Auto-saving...',
    saveChanges: 'Save Changes',
    confirmExitWithUnsaved: 'You have unsaved changes. Exit editing?',
    exitEdit: 'Exit Edit',
    enterTitle: 'Enter title',
    enterContent: 'Enter content',
    enterText: 'Enter text',
    invalidImageFormat: 'Invalid image format',
    imageProperties: 'Image Properties',
    newText: 'New Text',
    priority: 'Priority',
    text: 'Text',
    lighter: 'Lighter',
    width: 'Width',
    height: 'Height',
    rotation: 'Rotation',
    resetRotation: 'Reset rotation',
    reset: 'Reset',
    changeImage: 'Change Image',
    edit: 'Edit',
    resize: 'Resize',
    dragToMove: 'Drag to move',
    delete: 'Delete',
    deleted: 'Deleted',
    confirmDelete: 'Delete this element?',
    deleteWarning: 'This action cannot be undone.',
    dragToRotate: 'Drag to rotate',
    closePropertyPanel: 'Close property panel',
    sendToBack: 'Send to back',
    bringToFront: 'Bring to front',
    deleteElement: 'Delete element',
    popupBlocked: 'Popup blocked. Please allow popups.',
    generatingImage: 'Generating image...',
    generatingSlideImage: 'Generating slide image...',
    pleaseWait: 'Please wait.',
    imageGenerationComplete: 'Image generation complete!',
    downloadStarting: 'Download starting...',
    closeWindow: 'Close Window',
    errorOccurred: 'Error occurred',
    imageGenerationError: 'An error occurred while generating the image.',
  },
};